import { render, staticRenderFns } from "./changePsd.vue?vue&type=template&id=6aad01c6&scoped=true"
import script from "./changePsd.vue?vue&type=script&lang=ts"
export * from "./changePsd.vue?vue&type=script&lang=ts"
import style0 from "./changePsd.vue?vue&type=style&index=0&id=6aad01c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aad01c6",
  null
  
)

export default component.exports